import React from "react";
import Ajax, { domain } from "../ajax/Ajax";

class ContactDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      leaveMessage: true,
      name: "",
      email: "",
      phone: "",
      message: "",
      sending: false,
      messageSent: false,
      sendingError: false,
    };

    this.submitMessage = this.submitMessage.bind(this);
  }

  async submitMessage(event) {
    event.preventDefault();

    let data = {
      name: this.state.name,
      email: this.state.email,
      phone: this.state.phone,
      message: this.state.message,
    };
    this.setState({ sending: true });

    let response = await Ajax.postData(
      domain + "/en/api/accounts/v1/message/",
      data
    );
    if (response) {
      this.setState({
        messageSent: true,
        sendingError: false,
        sending: false,
        message: "",
        email: "",
        phone: "",
        name: "",
      });
    } else {
      this.setState({
        sending: false,
        sendingError: true,
        messageSent: false,
      });
    }
  }

  render() {
    let sending = "";
    if (this.state.sending) {
      sending = "is-loading";
    }

    return (
      <div className="animated fadeIn">
        <br />
        <br />
        <br />
        <div className="container">
          <div className="d-flex justify-content-center mt-4">
            <div className="is-size-4">
              <span>CONTACT US</span>
            </div>
          </div>
          <div className="columns mt-4">
            <div className="column is-4">
              <div className="">
                <div className="">
                  <div className="is-size-3 has-text-centered">
                    <span className="zmdi zmdi-gps has-text-info"></span>
                  </div>
                  <div className="mt-2 has-text-centered">
                    <div className="is-size-6">
                      Great Soppo, Buea
                      <br />
                      Cameroon
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="column is-4">
              <div className="">
                <div className="">
                  <div className="is-size-3 has-text-centered">
                    <span className="zmdi zmdi-phone has-text-info"></span>
                  </div>
                  <div className="mt-2 has-text-centered">
                    <div className="is-size-6">
                      +237 650 42 6514
                      <br />
                      +237 671 90 6987
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="column is-4">
              <div className="">
                <div className="">
                  <div className="is-size-3 has-text-centered">
                    <span className="zmdi zmdi-email has-text-info"></span>
                  </div>
                  <div className="mt-2 has-text-centered">
                    <div className="is-size-6">
                      contact@vehshop.com
                      <br />
                      sales@vehshop.com
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <br />
          <br />

          <div className="mt-4 container">
            {!this.state.leaveMessage ? (
              <div className="animated fadeIn has-text-centered is-hidden">
                <button
                  onClick={() => {
                    this.setState({
                      leaveMessage: true,
                    });
                  }}
                  className="button"
                >
                  <span className="zmdi zmdi-comments mr-2"></span>
                  <span>Leave a Message</span>
                </button>
              </div>
            ) : (
              <div className="columns animated zoomIn">
                <div className="column is-6 d-flex align-items-center justify-content-center">
                  <div className="is-size-2 has-text-centered">
                    Have a Question? <br /> Please drop us a Message!
                  </div>
                </div>
                <div className="column is-1"></div>
                <div className="column is-5">
                  <div className="card is-shadowless bordered-card">
                    <div className="card-content">
                      <div className="title has-text-centered is-hidden">
                        Leave a Message
                        <span className="ml-2">
                          <button
                            title="Close Message Box"
                            onClick={() => {
                              this.setState({
                                leaveMessage: false,
                              });
                            }}
                            className="delete"
                          ></button>
                        </span>
                      </div>
                      <div>
                        <form action="#" onSubmit={this.submitMessage}>
                          {this.state.messageSent ? (
                            <div className="message is-success animated fadeIn">
                              <div className="message-body has-text-centered">
                                <span className="zmdi zmdi-check-circle mr-2"></span>
                                <span>Message Sent!</span>
                              </div>
                            </div>
                          ) : (
                            <div></div>
                          )}

                          {this.state.sendingError ? (
                            <div className="message is-danger animated fadeIn">
                              <div className="message-body has-text-centered">
                                <span className="zmdi zmdi-close-circle mr-2"></span>
                                <span>
                                  An Error occurred! Please try again later.
                                </span>
                              </div>
                            </div>
                          ) : (
                            <div></div>
                          )}

                          <div className="field">
                            <input
                              value={this.state.name}
                              onChange={(event) => {
                                this.setState({ name: event.target.value });
                              }}
                              placeholder="Your Name"
                              type="text"
                              className="control input"
                              name="name"
                            />
                          </div>

                          <div className="field">
                            <input
                              value={this.state.email}
                              onChange={(event) => {
                                this.setState({ email: event.target.value });
                              }}
                              required
                              placeholder="Your Email"
                              type="email"
                              className="control input"
                              name="email"
                            />
                          </div>

                          <div className="field">
                            <input
                              value={this.state.phone}
                              onChange={(event) => {
                                this.setState({ phone: event.target.value });
                              }}
                              placeholder="Your Phone (+1 895 65 4521)"
                              type="text"
                              className="control input"
                              name="phone"
                            />
                          </div>

                          <div className="field">
                            <textarea
                              value={this.state.message}
                              onChange={(event) => {
                                this.setState({ message: event.target.value });
                              }}
                              required
                              placeholder="Your Message"
                              name="message"
                              id="contact-message"
                              rows="4"
                              className="textarea"
                            ></textarea>
                          </div>

                          <div className="field">
                            <button className={"button is-info " + sending}>
                              <span className="zmdi zmdi-mail-send mr-2"></span>
                              <span>Send</span>
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="column is-3"></div>
              </div>
            )}
          </div>
        </div>
        <br />
        <br />
      </div>
    );
  }
}

export default ContactDetails;
